import { z } from 'zod';

import { TaskType } from '__generated__/GQL';
import { tasksFormSchema } from 'features/Work/form/tasksForm.schema';

export const catalogItemFormSchema = tasksFormSchema
  .omit({
    units: true,
  })
  .extend({
    type: z.nativeEnum(TaskType),
  });

export type CatalogItemFormSchema = z.infer<typeof catalogItemFormSchema>;
